/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_No_AnswerInputs */

const bn_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোন উত্তর নেই`)
};

const de_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Antwort`)
};

const el_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καμία απάντηση`)
};

const en_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No answer`)
};

const es_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin respuesta`)
};

const fr_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune réponse`)
};

const hi_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई जवाब नहीं`)
};

const hu_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs válasz`)
};

const id_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada jawaban`)
};

const it_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna risposta`)
};

const ja_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`答えはありません`)
};

const ko_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`답변 없음`)
};

const nl_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen antwoord`)
};

const pl_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak odpowiedzi`)
};

const pt_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem resposta`)
};

const ru_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет ответа`)
};

const sv_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inget svar`)
};

const tr_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cevap yok`)
};

const uk_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відповіді немає`)
};

const vi_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có câu trả lời`)
};

const zh_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无人接听`)
};

const zh_hant_game_no_answer = /** @type {(inputs: Game_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無人接聽`)
};

/**
* | output |
* | --- |
* | "No answer" |
*
* @param {Game_No_AnswerInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_no_answer = /** @type {((inputs?: Game_No_AnswerInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_No_AnswerInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_no_answer(inputs)
	if (locale === "de") return de_game_no_answer(inputs)
	if (locale === "el") return el_game_no_answer(inputs)
	if (locale === "en") return en_game_no_answer(inputs)
	if (locale === "es") return es_game_no_answer(inputs)
	if (locale === "fr") return fr_game_no_answer(inputs)
	if (locale === "hi") return hi_game_no_answer(inputs)
	if (locale === "hu") return hu_game_no_answer(inputs)
	if (locale === "id") return id_game_no_answer(inputs)
	if (locale === "it") return it_game_no_answer(inputs)
	if (locale === "ja") return ja_game_no_answer(inputs)
	if (locale === "ko") return ko_game_no_answer(inputs)
	if (locale === "nl") return nl_game_no_answer(inputs)
	if (locale === "pl") return pl_game_no_answer(inputs)
	if (locale === "pt") return pt_game_no_answer(inputs)
	if (locale === "ru") return ru_game_no_answer(inputs)
	if (locale === "sv") return sv_game_no_answer(inputs)
	if (locale === "tr") return tr_game_no_answer(inputs)
	if (locale === "uk") return uk_game_no_answer(inputs)
	if (locale === "vi") return vi_game_no_answer(inputs)
	if (locale === "zh") return zh_game_no_answer(inputs)
	return zh_hant_game_no_answer(inputs)
});